module.exports = __webpack_public_path__ + "media/PAG88-03.ff36df23.mp3";